export default "__VITE_ASSET__IIxKI2ME__"